{
  "text": "<p>After several unsuccessful attempts to verify your identity, we’ve temporarily locked this invitation to protect your privacy.</p><p>Don’t worry – we can still help.</p><p>Please call our team to complete your booking:</p><p><a><strong>☎️ {{phone}}</strong></a> (then press <strong>Option 2</strong>)<br/>Monday to Friday, 8am–5pm.</p>",
  "title": "Invitation locked for your security"
}
